import * as React from 'react';
import { type GriffelRenderer, AriaLiveAnnouncer } from '@fluentui/react-components';
import { Helmet } from 'react-helmet';
import { FluentProvider } from '@foundershub/theme';
import { TitleProvider } from '../components';
import ico from '../media/favicon.ico';
import { CookieConsentContext } from '../modules/cookie-consent';
import { IntlProvider } from '../modules/intl';
import type { Locale } from '../modules/intl/locales';
import type { Keys } from '../modules/key-store';
import { KeyProvider } from '../modules/key-store';
import { AppWrapper } from '../modules/telemetry';
import type { Store } from '../store';
import { Provider as StoreProvider } from '../store';

export interface ContextWrapperProps {
  app: React.ComponentType;
  keys: Keys;
  locale: Locale;
  renderer?: GriffelRenderer;
  store: Store;
}

export function UniversalContextWrapper({ app, keys, locale, store, renderer }: ContextWrapperProps) {
  return (
    <FluentProvider renderer={renderer}>
      <AriaLiveAnnouncer>
        <KeyProvider value={keys}>
          <StoreProvider store={store}>
            <IntlProvider locale={locale}>
              <TitleProvider>
                <CookieConsentContext>
                  <Helmet>
                    <link rel="icon" href={ico} />
                    <style>{'html, body { margin: 0; padding: 0; }'}</style>
                  </Helmet>
                  <AppWrapper app={app} />
                </CookieConsentContext>
              </TitleProvider>
            </IntlProvider>
          </StoreProvider>
        </KeyProvider>
      </AriaLiveAnnouncer>
    </FluentProvider>
  );
}
